import { Box, styled } from "@tm/components"

export const ErrorBoxWrapper = styled(Box, { shouldForwardProp: (prop) => prop !== "isError" })<{ isError: boolean }>(({ isError }) => ({
    ...(isError && {
        border: "1px solid red",
        borderRadius: "3px",
    }),
}))
